import {useDictAll} from '../../../Utils/Hooks/useDict';

export function useDict() {
    return useDictAll(['Status', 'MenuType', 'H5ShowType', 'IconType']);
}
